
/// asset resolver function
export const asset = (path: string) => `${(window as any).CO2_CALCULATOR_ORIGIN || '.'}/${path}`

